export default __webpack_public_path__ + "static/media/logo-dark.5cdf58f7.svg";